import { ShoppingBag, Rocket, MessageCircle, ArrowUpRight } from "lucide-react";
import { ScrollReveal } from "./Reveal";

export const TOPIC_OPTIONS = [
  {
    id: "purchase",
    label: "Drone Purchase Advice",
    title: "DRONE PURCHASE",
    desc: "Budget ke andar best drone — DJI se custom FPV builds tak. Honest recommendation, zero brand bias.",
    icon: ShoppingBag,
  },
  {
    id: "fpv",
    label: "FPV Starter Plan",
    title: "FPV STARTER",
    desc: "Zero se first flight tak ka complete roadmap — simulator, radio, goggles, drone. Step by step.",
    icon: Rocket,
  },
  {
    id: "query",
    label: "Other Drone Query",
    title: "KOI BHI QUERY",
    desc: "Rules, repairs, cinematic shots, career in drones — jo bhi poochhna hai, seedha poochho.",
    icon: MessageCircle,
  },
];

export const Topics = ({ onBook }) => (
  <section id="topics" className="py-28 md:py-40 border-b border-ink/10 blueprint-bg">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <ScrollReveal>
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-flame">PICK YOUR MISSION</p>
        <h2 className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tight leading-[1.05] mt-8 text-ink">
          KIS BAARE MEIN<br />BAAT KARNI HAI<span className="text-flame">?</span>
        </h2>
      </ScrollReveal>
      <div className="grid md:grid-cols-3 gap-px bg-ink/10 border border-ink/10 mt-16">
        {TOPIC_OPTIONS.map((t, i) => (
          <ScrollReveal key={t.id} delay={i * 0.12}>
            <button
              data-testid={`topic-card-${t.id}`}
              onClick={() => onBook(t.id)}
              className="group w-full h-full text-left bg-white p-10 md:p-12 border border-transparent transition-all duration-300 flex flex-col hover:border-flame/70 hover:shadow-[0_0_40px_rgba(255,92,26,0.15)]"
            >
              <div className="flex items-start justify-between">
                <t.icon size={28} className="text-neutral-400 group-hover:text-flame transition-colors" />
                <span className="font-mono text-[10px] tracking-[0.25em] text-neutral-400">CH.0{i + 1}</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-semibold uppercase tracking-tight leading-snug mt-12 text-ink">{t.title}</h3>
              <p className="mt-5 text-neutral-600 leading-relaxed flex-1">{t.desc}</p>
              <span className="mt-10 inline-flex items-center gap-2 font-mono text-xs tracking-widest uppercase text-flame">
                Book this topic
                <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </span>
            </button>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);
